module.exports = __webpack_public_path__ + "img/high-emission.8e2ebc6c.svg";